const jointhepractice = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Join the Practice",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  rules: {
                    condition: {
                      key: "registration_form",
                      value: false,
                    },
                    actions: [
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "custom_message",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "namedgp",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "care_data",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "nhs_donor_registration",
                        newValue: false,
                      },
                      {
                        actionType: "CHANGE_VALUE",
                        targetKey: "patient_participation_group",
                        newValue: false,
                      },
                    ],
                  },
                  form: {
                    info_box: {
                      type: "checkbox",
                      label: "Add Information Box",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    boundary_map: {
                      type: "toggle",
                      label: "Boundary Map",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    boundaries: {
                      type: "mapboundary",
                      label: "Map",
                      displayOn: "boundary_map",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    registration_form: {
                      type: "toggle",
                      label: "Registration Form",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    registration_type: {
                      type: "select",
                      label: " ",
                      placeholder: "Select Form",
                      required: false,
                      displayOn: "registration_form",
                      displayOnValue: "true",
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Online Form", "External Registration"],
                    },
                    form_description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      displayOn: "registration_type",
                      displayOnValue: "External Registration",
                      displayOn2: "registration_form",
                      displayOnValue2: "true",
                      required: false,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    external_links: {
                      type: "textinputs",
                      label: "    ",
                      displayOn: "registration_type",
                      displayOnValue: "External Registration",
                      displayOn2: "registration_form",
                      displayOnValue2: "true",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      limit: 4,
                    },

                    // "help_us_help_you": {
                    //     "type": 'toggle',
                    //     "label": 'Help Us Help You',
                    //     "placeholder": '',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // hr4: {
                    //   type: "hr",
                    //   size: "12",
                    //   displayOn: "registration_form",
                    //   displayOnValue: "true",
                    // },
                    "confirmation-message": {
                      type: "ckeditor",
                      label: "Confirmation Message",
                      placeholder: "Confirmation Message",
                      displayOn: "registration_form",
                      displayOnValue: "true",
                      displayOn2: "registration_type",
                      displayOnValue2: "Online Form",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "editor-toolbar-bg-change",
                      size: "12",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                      displayOn: "registration_form",
                      displayOnValue: "true",
                      displayOn2: "registration_type",
                      displayOnValue2: "Online Form",
                    },
                    formSection1: {
                      components: {
                        custom_message: {
                          type: "toggle",
                          label: "Custom Message",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                          placeholder: "",
                          required: false,
                          info: true,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        custom_message_title: {
                          type: "text",
                          label: "Title ",
                          placeholder: "Enter title",
                          displayOn: "custom_message",
                          displayOnValue: "true",
                          required: true,
                          info: true,
                          character_count: 250,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        custom_message_description: {
                          type: "ckeditor",
                          label: "Description ",
                          placeholder: "Description",
                          displayOn: "custom_message",
                          displayOnValue: "true",
                          required: true,
                          info: false,
                          character_count: 2000,
                          disabled: false,
                          class: "editor-toolbar-bg-change",
                          size: "12",
                          style: "",
                        },
                        hr8: {
                          type: "hr",
                          size: "12",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                        },
                        nhs_donor_registration: {
                          type: "toggle",
                          label: "NHS Donor Registration",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                          placeholder: "",
                          required: false,
                          info: true,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        nhs_donor_registration_title: {
                          type: "text",
                          label: "Title   ",
                          placeholder: "Enter title",
                          displayOn: "nhs_donor_registration",
                          displayOnValue: "true",
                          required: true,
                          info: true,
                          character_count: 250,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        nhs_donor_registration_description: {
                          type: "ckeditor",
                          label: "Description   ",
                          placeholder: "Description",
                          displayOn: "nhs_donor_registration",
                          displayOnValue: "true",
                          required: true,
                          info: false,
                          character_count: 2000,
                          disabled: false,
                          class: "editor-toolbar-bg-change",
                          size: "12",
                          style: "",
                        },
                        hr9: {
                          type: "hr",
                          size: "12",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                        },
                        patient_participation_group: {
                          type: "toggle",
                          label: "Patient Participation Group",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                          placeholder: "",
                          required: false,
                          info: true,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        patient_participation_group_title: {
                          type: "text",
                          label: "Title   ",
                          placeholder: "Enter title",
                          displayOn: "patient_participation_group",
                          displayOnValue: "true",
                          required: true,
                          info: true,
                          character_count: 250,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        patient_participation_group_description: {
                          type: "ckeditor",
                          label: "Description   ",
                          placeholder: "Description",
                          displayOn: "patient_participation_group",
                          displayOnValue: "true",
                          required: true,
                          info: false,
                          character_count: 2000,
                          disabled: false,
                          class: "editor-toolbar-bg-change",
                          size: "12",
                          style: "",
                        },
                        hr6: {
                          type: "hr",
                          size: "12",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                        },
                        namedgp: {
                          type: "toggle",
                          label: "Named GP",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                          placeholder: "",
                          required: false,
                          info: true,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        namedgp_title: {
                          type: "text",
                          label: "Title  ",
                          placeholder: "Enter title",
                          displayOn: "namedgp",
                          displayOnValue: "true",
                          required: true,
                          info: true,
                          character_count: 250,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        namedgp_description: {
                          type: "ckeditor",
                          label: "Description  ",
                          placeholder: "Description",
                          displayOn: "namedgp",
                          displayOnValue: "true",
                          required: true,
                          info: false,
                          character_count: 2000,
                          disabled: false,
                          class: "editor-toolbar-bg-change",
                          size: "12",
                          style: "",
                        },
                        hr7: {
                          type: "hr",
                          size: "12",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                        },
                        care_data: {
                          type: "toggle",
                          label: "Care Data and NHS Digital",
                          displayOn: "registration_form",
                          displayOnValue: "true",
                          placeholder: "",
                          required: false,
                          info: true,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        care_data_title: {
                          type: "text",
                          label: "Title   ",
                          placeholder: "Enter title",
                          displayOn: "care_data",
                          displayOnValue: "true",
                          required: true,
                          info: true,
                          character_count: 250,
                          disabled: false,
                          class: "",
                          size: "12",
                          style: "",
                        },
                        care_data_description: {
                          type: "ckeditor",
                          label: "Description   ",
                          placeholder: "Description",
                          displayOn: "care_data",
                          displayOnValue: "true",
                          required: true,
                          info: false,
                          character_count: 2000,
                          disabled: false,
                          class: "editor-toolbar-bg-change",
                          size: "12",
                          style: "",
                        },
                      },
                      class: "",
                      size: "12",
                      style: "",
                      type: "formSection",
                    },

                    // "practice_location_check": {
                    //     "type": 'checkbox',
                    //     "label": 'Related Information',
                    //     "placeholder": 'Practice Location',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "practice_team_check": {
                    //     "type": 'checkbox',
                    //     "label": '1',
                    //     "hideLabel": true,
                    //     "placeholder": 'Practice Team',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "gp_and_nurse_availability_check": {
                    //     "type": 'checkbox',
                    //     "label": '2',
                    //     "hideLabel": true,
                    //     "placeholder": 'GP & Nurse Availablity',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "when_we_are_closed_check": {
                    //     "type": 'checkbox',
                    //     "label": '3',
                    //     "hideLabel": true,
                    //     "placeholder": 'When we are closed',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "contact_us_check": {
                    //     "type": 'checkbox',
                    //     "label": '4',
                    //     "hideLabel": true,
                    //     "placeholder": 'Contact Us',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "hr5": {
                    //     "type": 'hr',
                    //     "size": "12",
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "categoryOptions",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              addNewSuccessTitle: "Type Added!",
              addNewSuccessMessage: "Type Added Successfully!",
              addNewErrorTitle: "Type Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Type Deleted!",
              deleteSuccessMessage: "Type Deleted Successfully!",
              deleteErrorTitle: "Type Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Type Activated!",
              activeSuccessMessage: "Type Activated Successfully!",
              activeErrorTitle: "Type Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Type Updated!",
              updateSuccessMessage: "Type Updated Successfully!",
              updateErrorTitle: "Type Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Type",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Type",
                    placeholder: "Enter Type",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  template: {
                    type: "select",
                    label: "Template",
                    placeholder: "Select Template",
                    required: false,
                    info: false,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                    options: ["Template A"],
                  },
                },
              },
            },
            children: [
              {
                type: "optionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Types",
                  type: "typeList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    layout_1: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A"],
                      },
                    },
                    layout_2: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A"],
                      },
                      pharmacy_type: {
                        type: "select",
                        label: "Pharmacy",
                        placeholder: "Select Repeat",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        options: ["Predefined list", "Enter Manually"],
                      },
                      pharmacy_list: {
                        type: "variableListSingle",
                        label: "Pharmacy List",
                        placeholder: "select",
                        displayOn: "pharmacy",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "mb-2",
                        size: "12",
                        style: "",
                      },
                      please_specify: {
                        type: "checkbox",
                        label: "",
                        hideLabel: true,
                        placeholder: "Please specify",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "form-checkbox-new ml-50",
                        size: "12",
                        style: "",
                        portalkey: "pharmacy_list",
                      },
                    },
                    layout_3: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A"],
                      },
                      mandatory: {
                        type: "toggle",
                        label: "Mandatory",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      formSection1: {
                        components: {
                          mandatory_options: {
                            type: "select",
                            label: "",
                            placeholder: "Select",
                            required: false,
                            info: false,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            options: [
                              "All Cases",
                              "If Access to Medical Records selected",
                            ],
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOnValue: "true",
                        displayOn: "mandatory",
                      },
                    },
                    layout_4: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A"],
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      occupation_check: {
                        type: "checkbox",
                        label: "Mandatory Field Settings",
                        placeholder: "Occupation",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      previous_details_check: {
                        type: "checkbox",
                        label: "1",
                        hideLabel: true,
                        placeholder: "Previous Details",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                    },
                    layout_5: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A", "Template B"],
                      },
                    },
                    layout_6: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A", "Template B"],
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      occupation_check: {
                        type: "checkbox",
                        label: "Mandatory Field Settings",
                        placeholder: "Occupation",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      previous_details_check: {
                        type: "checkbox",
                        label: "1",
                        hideLabel: true,
                        placeholder: "Previous Details",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                    },
                    layout_7: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A", "Template B"],
                      },
                      pharmacy_type: {
                        type: "select",
                        label: "Pharmacy",
                        placeholder: "Select Repeat",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        options: ["Predefined list", "Enter Manually"],
                      },
                      pharmacy_list: {
                        type: "variableListSingle",
                        label: "Pharmacy List",
                        placeholder: "select",
                        displayOn: "pharmacy",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "mb-2",
                        size: "12",
                        style: "",
                      },
                      please_specify: {
                        type: "checkbox",
                        label: "",
                        hideLabel: true,
                        placeholder: "Please specify",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "form-checkbox-new ml-50",
                        size: "12",
                        style: "",
                        portalkey: "pharmacy_list",
                      },
                    },
                    layout_8: {
                      template: {
                        type: "select",
                        label: "Template",
                        placeholder: "Select Template",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Template A", "Template B"],
                      },
                      mandatory: {
                        type: "toggle",
                        label: "Mandatory",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      formSection1: {
                        components: {
                          mandatory_options: {
                            type: "select",
                            label: "",
                            placeholder: "Select",
                            required: false,
                            info: false,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            options: [
                              "All Cases",
                              "If Access to Medical Records selected",
                            ],
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOnValue: "true",
                        displayOn: "mandatory",
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { jointhepractice };
